module.exports = __webpack_public_path__ + "static/img_partnerNftHorizonDefault-6fe76299ab46bd10284adfeb7a6a5cfe.png";